import React from "react";
import Button from "sushiweb/Button";
import PropTypes from "prop-types";
import NoFooterModal from "../NoFooterModal";
import { BottomSectionModal } from "../../../constants/assets/containers";

const ConfirmationModal = (props) => {
  const {
    open,
    modalTitle,
    onCofirmCancelHandler,
    onCofirmSuccessHandler,
    successButtonText,
    CancelButtonText,
    id,
  } = props;

  return open ? (
    <NoFooterModal
      header={true}
      heading={modalTitle}
      handleClose={onCofirmCancelHandler}
      id={id || "confirmationDialog"}
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          <Button
            data-testid="cancelButtonConfirmationDialog"
            onClick={onCofirmCancelHandler}
            appearance="outline"
            className="sushi-btn"
          >
            {CancelButtonText || "Cancel"}
          </Button>
          <Button
            data-testid="submitButtonConfirmationDialog"
            className="sushi-btn"
            onClick={onCofirmSuccessHandler}
          >
            {successButtonText}
          </Button>
        </BottomSectionModal>
      }
    >
      {props.children}
    </NoFooterModal>
  ) : (
    ""
  );
};

ConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  modalTitle: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onCofirmCancelHandler: PropTypes.func.isRequired,
  onCofirmSuccessHandler: PropTypes.func.isRequired,
  successButtonText: PropTypes.string.isRequired,
};

export default ConfirmationModal;
